export default {
  title: 'Instellingen',
  reservation_hours_helper: 'Deze uren bepalen wanneer gasten online kunnen reserveren.',
  reservation_hours_alert:
    'Uw reserveringsuren wijken af van uw reguliere openingstijden. Gasten kunnen alleen boeken tijdens de hier vermelde uren.',
  activated: 'Reserveringen actief',
  deactivated: 'Reserveringen inactief',
  buttons: {
    activate: 'Activeren',
    deactivate: 'Deactiveren',
  },
  error_messages: {
    no_google_place: {
      title: 'Het restaurant is niet gekoppeld aan een Google-locatie',
      description: 'Koppel het restaurant aan een Google-locatie',
    },
    toggle_failed: 'Reserveringen konden niet worden bijgewerkt. Probeer het opnieuw.',
  },
};
